<template>
    <div>
        <folder-navigation-actions type="collections"/>
        <collections-by-folder :folder="folder" :is-root="true" />
    </div>
</template>

<script>
import CollectionsByFolder from "./CollectionsByFolder"
import { mapGetters } from 'vuex';
import Roles from '@/utilities/Roles'
import SidebarNewCollectionButton from "@/components/Collections/SidebarNewCollectionButton";
import FolderNavigationActions from "@/components/Folders/FolderNavigationActions";

export default {
    name: "SidebarList",
    mixins : [Roles],
    components : {
        FolderNavigationActions,
        CollectionsByFolder, SidebarNewCollectionButton

    },
    computed : {
        ...mapGetters({
            folders : 'folders',
            currentAccountOverview : 'currentAccountOverview',
        }),
        folder(){
            if (!this.currentAccountOverview?.root) return null;
            return this.folders.find(f => this.currentAccountOverview.root.includes(f.id));
        }
    },
    methods : {
        showCollectionBuilder(){
            window.Events.$emit('show_editCollectionModal', {collection: null});
        }
    }
}
</script>

